export const oficina = [
    {
      label: "Id",
      name: "idoficina",
      type: "INTEGER",
      readonly: true,
      showOnList: true,
    },
    {
      label: "Nombre",
      name: "nombre",
      type: "STRING",
      allowNull: false,
      showOnList: true,
      showAsLabel: true,
    },
    {
      label: "País",
      name: "pais",
      type: "STRING",
      showOnList: true,
      allowNull: false,
    },
];
